import { HTMLAttributes, useEffect, useRef } from 'react';
import { StyledLimitContent } from './LimitContent.styles';

export interface LimitContentProps extends HTMLAttributes<HTMLDivElement> {
  maxLines: number;
  onMaxLinesReached: () => void;
}

const LimitContent = ({
  children,
  maxLines,
  onMaxLinesReached,
  ...restProps
}: LimitContentProps) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current) {
      const lineHeight = +window
        .getComputedStyle(ref.current)
        .getPropertyValue('line-height')
        .replace('px', '');

      const textHeight = ref.current.scrollHeight;
      const numLines = textHeight / lineHeight;

      if (numLines > maxLines) onMaxLinesReached();
    }
  }, [ref.current]);

  return (
    <StyledLimitContent ref={ref} maxLines={maxLines} {...restProps}>
      {children}
    </StyledLimitContent>
  );
};

export default LimitContent;
